import UserMergeModal from '@web/users/UserMerge/UserMergeModal';

import r2a from '../../angularIntegration/r2a';

export default r2a({
  ReactComponent: UserMergeModal,
  bindings: {
    isOpen: '<',
    fromUsers: '<',
    availableUsers: '<',
    onSubmit: '&',
    onClose: '&',
  },
});
